import script from "./SingleChat.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleChat.vue?vue&type=script&setup=true&lang=js"

import "./SingleChat.vue?vue&type=style&index=0&id=e2371480&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e2371480"]])

export default __exports__